__turbopack_context__.v({
  "button": "Pickup-module-scss-module__BFCwEW__button",
  "header": "Pickup-module-scss-module__BFCwEW__header",
  "map": "Pickup-module-scss-module__BFCwEW__map",
  "mapBody": "Pickup-module-scss-module__BFCwEW__mapBody",
  "tabs": "Pickup-module-scss-module__BFCwEW__tabs",
});
